//random utility functions

export function convertHTMLstringtoHTML(htmlString) {
    const temp = document.createElement("div");
    temp.innerHTML = htmlString.replace(/[\n\r\t]+/g, " ").replace(/\s+/g, " "); //removes tabs and line breaks only
    return temp.firstElementChild;

    //ALERT: because we want actual html node and firstElementChild is the only way
    //MUST have html wrapped under one single parent tag
}

export function convertOptionHTMLstringToHTML(htmlString, indexAmount) {
    const option = convertHTMLstringtoHTML(htmlString);
    option.text = "\u00A0".repeat(indexAmount) + option.text;
    return option;

    //this was created because we have legitmate use case for option tags in select tags with extra white spaces pre-pending
    //it's annoying because we can't use optgroup tag, it's not selectable and cannot be made selectable with javascript
    //additionally option tag itself cannot have any margin, padding, or text-index
    //option tag also cannot have :before to add white space
}

export function replaceHashWithSearchArg(filter) {
    const loc = window.location;
    const url = `${loc.protocol}//${loc.host}${loc.path ? loc.path : ""}${loc.pathname}${filter}`;
    history.replaceState({}, "", url);
}

export function splitCamel(s) {
    return s.replace(/([a-z])([A-Z])/g, "$1 $2").toUpperCase();
}

export function areSetsEqual(setA, setB) {
    if (setA.size === setB.size) {
        return [...setA].every((a) => setB.has(a));
    }
    return false;
}
